module.exports = __webpack_public_path__ + "static/oW2e32.tif-63c043501d2493f5c013cdd9d378388d.png";